import { render, staticRenderFns } from "./tab-tree.vue?vue&type=template&id=2c79ff65&scoped=true"
import script from "./tab-tree.vue?vue&type=script&lang=js"
export * from "./tab-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79ff65",
  null
  
)

export default component.exports